import {IconProps} from './types';

const SwipeHand = ({fill = 'currentColor', className}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        fill={'none'}
        viewBox="0 0 24 24"
        className={className}
    >
        <path stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M8 13V5.5a1.5 1.5 0 0 1 3 0V12" />
        <path stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M11 11.5v-2a1.5 1.5 0 0 1 3 0V12" />
        <path stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M14 10.5a1.5 1.5 0 0 1 3 0V12" />
        <path
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M17 11.5a1.5 1.5 0 0 1 3 0V16a6 6 0 0 1-6 6h-2a6 6 0 0 1-5-2.7l-2.8-4.2a1.5 1.5 0 0 1 .5-2 1.9 1.9 0 0 1 2.3.3L8 15"
        />
    </svg>
);

export default SwipeHand;
